import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { invSearchOptions, invSearchOptionsCar, selectDateOrTime, selectDateOrTimeCar } from "../../../../../services/saleAnalysis-services";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    chip: {
        paddingLeft: "10px",
        paddingRight: "10px",
        marginLeft: "10px",
    },
}));

const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

const SearchInvoiceFilters = (props) => {
    const { rptParamsSearch, setRptParamsSearch, isPurches,permistionInv,AutoOptions,PcIdIvPc } = props;
    const optionsCar =["12","02","149","150"].includes(PcIdIvPc)? AutoOptions?.StepTwo?.id === 1?  invSearchOptionsCar: 
    selectDateOrTimeCar :selectDateOrTimeCar; 
    const options = ["12","02","149","150"].includes(PcIdIvPc)? AutoOptions?.StepTwo?.id === 1 ?  invSearchOptions: selectDateOrTime:selectDateOrTime;
    
    const classes = useStyles();
    const { t } = useTranslation(["forms"]);

    return (
        <>
            {permistionInv?.SHOWCAR ? (
                <Container
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        padding: "10px",
                        margin: "0px",
                    }}
                    component="ul"
                >
                    {optionsCar.map((x) => {
                        return (
                            <ListItem key={x.id}>
                                {x.id === rptParamsSearch.selectTime.id ? (
                                    <Chip
                                        className={classes.chip}
                                        label={t(x.label)}
                                        icon={<Done />}
                                        style={{
                                            backgroundColor: isPurches ? colors.blue[300] : colors.green[300],
                                            color: "#fff",
                                        }}
                                        clickable
                                    />
                                ) :
                                    (
                                        <Chip
                                            className={classes.chip}
                                            label={t(x.label)}
                                            variant="outlined"
                                            color={isPurches ? "blue" : "green"}
                                            onClick={() => {
                                                setRptParamsSearch({ ...rptParamsSearch, selectTime: x });
                                            }}
                                        />
                                    )}
                            </ListItem>
                        );
                    })}
                </Container>
            ) :
                <Container
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        padding: "10px",
                        margin: "0px",
                    }}
                    component="ul"
                >
                    {options.map((x) => {
                        return (
                            <ListItem key={x.id}>
                                {x.id === rptParamsSearch.selectTime.id ? (
                                    <Chip
                                        className={classes.chip}
                                        label={t(x.label)}
                                        icon={<Done />}
                                        style={{
                                            backgroundColor: isPurches ? colors.blue[300] : colors.green[300],
                                            color: "#fff",
                                        }}
                                        clickable
                                    />
                                ) :
                                    (
                                        <Chip
                                            className={classes.chip}
                                            label={t(x.label)}
                                            variant="outlined"
                                            color={isPurches ? "blue" : "green"}
                                            onClick={() => {
                                                setRptParamsSearch({ ...rptParamsSearch, selectTime: x });
                                            }}
                                        />
                                    )}
                            </ListItem>
                        );
                    })}
                </Container>}
        </>

    );
};

export default SearchInvoiceFilters;
